module.exports = __webpack_public_path__ + "media/SetA_L1_C_twice.17dd5068.mp3";